import { esignApiRoot } from './root';

export const api = esignApiRoot;
